import React, { Component } from "react";
import { Button, Form } from "antd";
import { connect } from "react-redux";
import QueryString from 'query-string';
import { isEmpty } from 'lodash';
import { setToken, getUserInfo } from "src/appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import InfoView from "components/InfoView";
import config from "util/config";
import { setCookieValue } from 'src/util/Common';
import { listVaiTro, convertVaiTroUserToListAsCamel, extractToRedirect } from 'src/helpers/Authorization';

const FormItem = Form.Item;

class SignIn extends Component {

  state = {
    token: '',
    redirect: false,
    vaiTroAvailble: false
  }

  async componentDidMount() {
    const { location, setToken, getUserInfo } = this.props;
    const query = await QueryString.parse(location.search);
    if (query.token) {
      await setCookieValue('accessTokensct', query.token);
      await setToken(query.token);
      await getUserInfo();
      this.setState({ token: query.token });
    }
    if (location.state && location.state.from.pathname.includes('Forbidden')) {
      this.props.history.push('/Forbidden');
    }
  }

  async componentDidUpdate() {
    const { token, redirect } = this.state;
    const { auth } = this.props;
    if (token && auth && !isEmpty(auth.authUser) && !redirect) {
      // Xử lý dữ liệu để reditect
      const vaiTro = listVaiTro(auth.authUser);
      const listVaiTroArr = convertVaiTroUserToListAsCamel(vaiTro);
      const urlToRedirect = extractToRedirect(listVaiTroArr);
      await setCookieValue('defaultUrlsct', urlToRedirect);
      await this.setState({ redirect: true }, () => {
        setTimeout(() => this.props.history.push({
          pathname: "/user/home"
        }), 1000)
      });
    }
  }

  /**
   * Chuyển sang trang đăng nhập tập trung
   *
   * @param {*} e
   * @memberof SignIn
   */
  handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = config.API_URL + "/secure/token?redirectTo=" + window.location.href;
  };

  render() {
    const { token } = this.state;
    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/* <img src={require("assets/images/logoQN.png")} alt='Quang Nam Provider' /> */}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.signIn" /></h1>
                <p><IntlMessages id="app.userAuth.bySigning" /></p>
                <p><IntlMessages id="app.userAuth.getAccount" /></p>
              </div>
              <div className="gx-app-logo">
                <img alt="example" src={require("assets/images/logoQTIdata.png")} />
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                <FormItem>
                  {!token ?
                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                      <IntlMessages id="app.userAuth.signIn" />
                    </Button>
                    :
                    <Button>Đang chuyển trang</Button>
                  }
                </FormItem>
                <span
                  className="gx-text-light gx-fs-sm"> Liên hệ hỗ trợ: sales@qti.vn</span>
              </Form>
            </div>
            <InfoView />
          </div>
        </div>
      </div>
    );

  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth }) => {
  return { auth }
};

export default connect(mapStateToProps, { setToken, getUserInfo })(WrappedNormalLoginForm);
